import {
  Card,
  Stack,
  Notice,
  Inline,
  ButtonLink,
  Text,
} from 'braid-design-system';
import React from 'react';

import Urls from 'src/config/routes';

export const ListingProductNotFoundError = () => (
  <Card data={{ testid: 'listing-product-not-found-error' }}>
    <Stack space="small">
      <Notice tone="critical">
        <Text>There was an error. Please try and select a product again.</Text>
      </Notice>

      <Inline space="none">
        <ButtonLink href={Urls.PACKAGES}>Select a product</ButtonLink>
      </Inline>
    </Stack>
  </Card>
);
